export const rankColor = {
  Exceptional: "text-green-700 font-bold",
  "Very Good": "text-green-500 font-bold",
  Good: "text-blue-500 font-bold",
  Fair: "text-yellow-500 font-bold",
  Poor: "text-red-500 font-bold",
};
